module.exports = __webpack_public_path__ + "static/media/topBarClock.0ae90b55.svg";